// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ViralClips.css */
.viral-clips {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .viral-clips h2 {
    text-align: center;
    margin-bottom: 32px;
    color: #7209b7;
    font-size: 28px;
  }
  
  /* Horizontal layout styles */
  .clips-container-horizontal {
    display: flex;
    overflow-x: auto;
    gap: 24px;
    padding-bottom: 16px;
    -ms-overflow-style: none; /* Hide scrollbar in IE and Edge */
    scrollbar-width: none; /* Hide scrollbar in Firefox */
  }
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  .clips-container-horizontal::-webkit-scrollbar {
    display: none;
  }
  
  /* Loading message style */
  .loading-message {
    width: 100%;
    padding: 20px;
    text-align: center;
    color: #7209b7;
    background-color: rgba(114, 9, 183, 0.05);
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    animation: pulse 1.5s ease-in-out infinite;
  }
  
  @keyframes pulse {
    0% { opacity: 0.7; }
    50% { opacity: 1; }
    100% { opacity: 0.7; }
  }
  
  .no-clips-message {
    width: 100%;
    padding: 20px;
    text-align: center;
    color: #666;
    background-color: #f5f5f5;
    border-radius: 8px;
    font-size: 16px;
  }
  
  .clip-card-horizontal {
    flex: 0 0 auto;
    width: calc(100% - 24px);
    max-width: 480px;
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
  }
  
  .clip-card-horizontal:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
  
  .clip-card-horizontal.expanded {
    transform: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .clip-preview-horizontal {
    display: flex;
    flex-direction: column;
  }
  
  .clip-preview-horizontal video {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
  }
  
  .clip-info-horizontal {
    padding: 16px;
  }
  
  .clip-info-horizontal h3 {
    font-size: 18px;
    margin-bottom: 8px;
    color: #7209b7;
  }
  
  .clip-stats-horizontal {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 14px;
    color: #666;
  }
  
  .clip-description {
    margin-bottom: 16px;
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .clip-actions-horizontal {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
  }
  
  .download-button {
    padding: 10px 16px;
    background-color: #7209b7;
    color: white;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
    width: 100%;
  }
  
  .download-button:hover {
    background-color: #5c0996;
  }
  
  .share-buttons-horizontal {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }
  
  .share-buttons-horizontal button {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    font-size: 12px;
    background-color: #f5f5f5;
    color: #333;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .share-buttons-horizontal button:hover {
    background-color: #e0e0e0;
  }
  
  .platform-icon {
    font-size: 16px;
    margin-right: 4px;
  }
  
  .clip-insights-horizontal {
    padding: 16px;
    background-color: rgba(114, 9, 183, 0.05);
    border-top: 1px solid #e0e0e0;
  }
  
  .clip-insights-horizontal h4 {
    font-size: 16px;
    margin-bottom: 12px;
    color: #7209b7;
  }
  
  .clip-insights-horizontal ul {
    list-style-type: none;
    padding: 0;
  }
  
  .clip-insights-horizontal li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.5;
  }
  
  .clip-insights-horizontal li:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #7209b7;
    font-weight: bold;
  }
  
  /* Media queries for responsive design */
  @media (max-width: 768px) {
    .clips-container-horizontal {
      flex-direction: column;
      gap: 16px;
    }
    
    .clip-card-horizontal {
      width: 100%;
      max-width: none;
    }
    
    .share-buttons-horizontal {
      flex-direction: column;
    }
  }
  
  @media (min-width: 1024px) {
    .clips-container-horizontal {
      padding-bottom: 24px;
    }
    
    .clip-card-horizontal {
      width: calc(33.333% - 16px);
    }
  }

  .mobile-phone-container {
    position: relative;
    width: 280px;
    height: 500px;
    margin: 0 auto;
    background-color: #111;
    border-radius: 36px;
    border: 8px solid #333;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
    padding: 5px;
    overflow: hidden;
  }
  
  .mobile-phone-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 20px;
    background-color: #333;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    z-index: 2;
  }
  
  .mobile-phone-container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 24px;
  }

  .video-container {
    width: 280px;
    height: 500px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 24px;
  }
  
  .video-container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 24px;
  }`, "",{"version":3,"sources":["webpack://./src/components/css/ViralClips.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,wBAAwB,EAAE,kCAAkC;IAC5D,qBAAqB,EAAE,8BAA8B;EACvD;;EAEA,gDAAgD;EAChD;IACE,aAAa;EACf;;EAEA,0BAA0B;EAC1B;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,yCAAyC;IACzC,qDAAqD;IACrD,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,yCAAyC;IACzC,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,oBAAoB;IACtB;;IAEA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;IAC/B,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB","sourcesContent":["/* src/components/ViralClips.css */\n.viral-clips {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 24px;\n    background-color: #fff;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .viral-clips h2 {\n    text-align: center;\n    margin-bottom: 32px;\n    color: #7209b7;\n    font-size: 28px;\n  }\n  \n  /* Horizontal layout styles */\n  .clips-container-horizontal {\n    display: flex;\n    overflow-x: auto;\n    gap: 24px;\n    padding-bottom: 16px;\n    -ms-overflow-style: none; /* Hide scrollbar in IE and Edge */\n    scrollbar-width: none; /* Hide scrollbar in Firefox */\n  }\n  \n  /* Hide scrollbar for Chrome, Safari and Opera */\n  .clips-container-horizontal::-webkit-scrollbar {\n    display: none;\n  }\n  \n  /* Loading message style */\n  .loading-message {\n    width: 100%;\n    padding: 20px;\n    text-align: center;\n    color: #7209b7;\n    background-color: rgba(114, 9, 183, 0.05);\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    margin-bottom: 20px;\n    animation: pulse 1.5s ease-in-out infinite;\n  }\n  \n  @keyframes pulse {\n    0% { opacity: 0.7; }\n    50% { opacity: 1; }\n    100% { opacity: 0.7; }\n  }\n  \n  .no-clips-message {\n    width: 100%;\n    padding: 20px;\n    text-align: center;\n    color: #666;\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    font-size: 16px;\n  }\n  \n  .clip-card-horizontal {\n    flex: 0 0 auto;\n    width: calc(100% - 24px);\n    max-width: 480px;\n    border-radius: 12px;\n    overflow: hidden;\n    background-color: #fff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .clip-card-horizontal:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  }\n  \n  .clip-card-horizontal.expanded {\n    transform: none;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .clip-preview-horizontal {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .clip-preview-horizontal video {\n    width: 100%;\n    aspect-ratio: 16/9;\n    object-fit: cover;\n    border-radius: 12px 12px 0 0;\n  }\n  \n  .clip-info-horizontal {\n    padding: 16px;\n  }\n  \n  .clip-info-horizontal h3 {\n    font-size: 18px;\n    margin-bottom: 8px;\n    color: #7209b7;\n  }\n  \n  .clip-stats-horizontal {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    font-size: 14px;\n    color: #666;\n  }\n  \n  .clip-description {\n    margin-bottom: 16px;\n    font-size: 14px;\n    color: #333;\n    line-height: 1.5;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .clip-actions-horizontal {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 16px;\n  }\n  \n  .download-button {\n    padding: 10px 16px;\n    background-color: #7209b7;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    width: 100%;\n  }\n  \n  .download-button:hover {\n    background-color: #5c0996;\n  }\n  \n  .share-buttons-horizontal {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n  }\n  \n  .share-buttons-horizontal button {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    font-size: 12px;\n    background-color: #f5f5f5;\n    color: #333;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  \n  .share-buttons-horizontal button:hover {\n    background-color: #e0e0e0;\n  }\n  \n  .platform-icon {\n    font-size: 16px;\n    margin-right: 4px;\n  }\n  \n  .clip-insights-horizontal {\n    padding: 16px;\n    background-color: rgba(114, 9, 183, 0.05);\n    border-top: 1px solid #e0e0e0;\n  }\n  \n  .clip-insights-horizontal h4 {\n    font-size: 16px;\n    margin-bottom: 12px;\n    color: #7209b7;\n  }\n  \n  .clip-insights-horizontal ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .clip-insights-horizontal li {\n    position: relative;\n    padding-left: 20px;\n    margin-bottom: 10px;\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  \n  .clip-insights-horizontal li:before {\n    content: \"•\";\n    position: absolute;\n    left: 0;\n    color: #7209b7;\n    font-weight: bold;\n  }\n  \n  /* Media queries for responsive design */\n  @media (max-width: 768px) {\n    .clips-container-horizontal {\n      flex-direction: column;\n      gap: 16px;\n    }\n    \n    .clip-card-horizontal {\n      width: 100%;\n      max-width: none;\n    }\n    \n    .share-buttons-horizontal {\n      flex-direction: column;\n    }\n  }\n  \n  @media (min-width: 1024px) {\n    .clips-container-horizontal {\n      padding-bottom: 24px;\n    }\n    \n    .clip-card-horizontal {\n      width: calc(33.333% - 16px);\n    }\n  }\n\n  .mobile-phone-container {\n    position: relative;\n    width: 280px;\n    height: 500px;\n    margin: 0 auto;\n    background-color: #111;\n    border-radius: 36px;\n    border: 8px solid #333;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n    padding: 5px;\n    overflow: hidden;\n  }\n  \n  .mobile-phone-container::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 120px;\n    height: 20px;\n    background-color: #333;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    z-index: 2;\n  }\n  \n  .mobile-phone-container video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 24px;\n  }\n\n  .video-container {\n    width: 280px;\n    height: 500px;\n    margin: 0 auto;\n    overflow: hidden;\n    border-radius: 24px;\n  }\n  \n  .video-container video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 24px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
